// test2250
(2250 && 0);
